export default class PageNavigationService {
    constructor(
        $sbPageAccess,
        $sbTemplate,
        $state,
        SABLONO_STATES,
        $sbFeatureDecisions,
        FeatureFlags,
        EnvironmentFlags
    ) {
        "ngInject";

        this.$sbPageAccess = $sbPageAccess;
        this.$state = $state;
        this.$sbTemplate = $sbTemplate;
        this.PAGE = SABLONO_STATES;
        this.$sbFeatureDecisions = $sbFeatureDecisions;
        this.FeatureFlags = FeatureFlags;
        this.EnvironmentFlags = EnvironmentFlags;
    }

    /**
     * Logic based on https://sablono.atlassian.net/browse/SAB-14809
     */
    async goToLandingPage(project) {
        const templates = await this.$sbTemplate.getTemplates();
        const isHavingCompleteTracker = templates.some(
            (template) =>
                template.USED_IN_COMPONENTS > 0 && template.ACTIVITIES_COUNT > 0
        );

        const isTrackerLandingPage = this.$sbFeatureDecisions.isFeatureEnabled(
            this.FeatureFlags.TrackerAsLandingPage
        );
        // Logic based on https://sablono.atlassian.net/browse/SAB-15665
        const isTrackerFirstPage =
            !isHavingCompleteTracker || isTrackerLandingPage;

        // Since https://sablono.atlassian.net/browse/SAB-17045 my work is default entry page
        let primaryTarget = [this.PAGE.myWork, this.PAGE.tracker];
        if (isTrackerFirstPage) {
            primaryTarget = [this.PAGE.tracker, this.PAGE.dashboardPro];
        }

        const pagePriorities = [
            ...primaryTarget,
            this.PAGE.visualization,
            this.PAGE.leanBoard,
            this.PAGE.requestAccessLeanPlanning,
        ];

        let targetPage = pagePriorities.find((page) =>
            this.$sbPageAccess.isAccessible(page, project.privileges)
        );

        if (!targetPage) {
            // the ultimate fallback because the project settings page has currently no restrictions at all.
            //  should not happen but it prevents a navigation with undefined "target state"
            targetPage = this.PAGE.projectSettings;
        }

        return this.$state.go(targetPage, { projectId: project.id });
    }
}
